type SpinnerSize = 'sm' | 'md' | 'lg';

interface GabSpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

export function GabSpinner({ size = 'md', className = '' }: GabSpinnerProps) {
  const sizeClass = size === 'sm' ? 'spinner-sm' : size === 'lg' ? 'spinner-lg' : '';
  return <div className={`spinner ${sizeClass} ${className}`} role="status" aria-label="Loading" />;
}
